import { render, staticRenderFns } from "./NewRemarkPopup.vue?vue&type=template&id=0d189531&scoped=true&"
import script from "./NewRemarkPopup.vue?vue&type=script&lang=js&"
export * from "./NewRemarkPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewRemarkPopup.vue?vue&type=style&index=0&id=0d189531&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d189531",
  null
  
)

export default component.exports